import React from 'react';
import { Form, Input, Row, Col, Divider, Spin } from 'antd';
import { UserOutlined, MailOutlined, LockOutlined } from '@ant-design/icons';
import { FormInstance } from 'antd/lib/form/Form';

interface BasicDataFormProps {
  form: FormInstance;
  usernameChecking: boolean;
}

const BasicDataForm: React.FC<BasicDataFormProps> = ({ usernameChecking }) => {
  return (
    <>
      <Divider orientation="left">Basic Information</Divider>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="firstName"
            label="First Name"
            rules={[{ required: true, message: 'First name is required' }]}
          >
            <Input prefix={<UserOutlined />} placeholder="First Name" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="lastName"
            label="Last Name"
            rules={[{ required: true, message: 'Last name is required' }]}
          >
            <Input prefix={<UserOutlined />} placeholder="Last Name" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: 'Email is required' },
              { type: 'email', message: 'Please enter a valid email' },
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="Email Address" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="password"
            label="Password"
            rules={[
              { required: true, message: 'Password is required' },
              {
                min: 8,
                message: 'Password must be at least 8 characters',
              },
              {
                pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
                message:
                  'Password must contain uppercase, lowercase and number',
              },
            ]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="Password" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="username"
            label="Username"
            rules={[
              { required: true, message: 'Username is required' },
              {
                min: 3,
                message: 'Username must be at least 3 characters',
              },
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Choose a unique username"
              suffix={usernameChecking ? <Spin size="small" /> : null}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="profileName"
            label="Profile Name"
            rules={[{ required: true, message: 'Profile name is required' }]}
          >
            <Input placeholder="Display name for profile" />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default BasicDataForm;
